import React, { useState } from "react";

const StoreFrancoLab = ({ onClose }) => {
  const [selectedApp, setSelectedApp] = useState(null);

  const apps = [
    {
      id: 1,
      name: "FrancoGas Station",
      category: "Fuel Logistics",
      description: "Sistema de gestión de expendio de combustible en tiempo real con pagos crypto integrados.",
      image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=400",
      qr: "QR_GAS_STATION" 
    },
    {
      id: 2,
      name: "Warehouse Pro 2050",
      category: "Inventory AI",
      description: "Control de stock mediante visión artificial. Optimización de estanterías y rutas de picking.",
      image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=400",
      qr: "QR_WAREHOUSE"
    },
    {
      id: 3,
      name: "Cyber-Courier",
      category: "Delivery Bot",
      description: "Gestión de drones y vehículos autónomos de entrega. Seguimiento satelital encriptado.",
      image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&q=80&w=400",
      qr: "QR_DELIVERY"
    }
  ];

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      backgroundColor: "rgba(0, 5, 15, 0.95)", backdropFilter: "blur(20px)",
      zIndex: 2000, color: "white", padding: "40px", overflowY: "auto",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      {/* HEADER DE LA TIENDA */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "40px", borderBottom: "1px solid #00ffff" }}>
        <h1 style={{ color: "#00ffff", textTransform: "uppercase", letterSpacing: "5px", fontSize: "32px" }}>
          StoreFrancoLab <span style={{ fontSize: "12px", verticalAlign: "middle", opacity: 0.5 }}>v2.0.50</span>
        </h1>
        <button onClick={onClose} style={{ background: "transparent", border: "1px solid #00ffff", color: "#00ffff", padding: "10px 20px", cursor: "pointer", borderRadius: "5px" }}>
          SALIR DEL PORTAL
        </button>
      </div>

      {/* GRID DE APLICACIONES */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "30px" }}>
        {apps.map(app => (
          <div key={app.id} 
               onClick={() => setSelectedApp(app)}
               style={{
                background: "rgba(0, 255, 255, 0.05)", border: "1px solid rgba(0, 255, 255, 0.2)",
                borderRadius: "15px", overflow: "hidden", cursor: "pointer", transition: "0.3s",
                boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
               }}
               onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-10px)"; e.currentTarget.style.borderColor = "#00ffff"; }}
               onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.borderColor = "rgba(0, 255, 255, 0.2)"; }}
          >
            <img src={app.image} alt={app.name} style={{ width: "100%", height: "180px", objectFit: "cover", opacity: 0.7 }} />
            <div style={{ padding: "20px" }}>
              <span style={{ fontSize: "10px", color: "#00ffff", textTransform: "uppercase", letterSpacing: "2px" }}>{app.category}</span>
              <h3 style={{ margin: "5px 0" }}>{app.name}</h3>
              <p style={{ fontSize: "13px", opacity: 0.6 }}>Haga clic para ver planos y descarga.</p>
            </div>
          </div>
        ))}
      </div>

      {/* MODAL DE DETALLE (Holograma de Descarga) */}
      {selectedApp && (
        <div style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          display: "flex", justifyContent: "center", alignItems: "center", background: "rgba(0,0,0,0.8)"
        }} onClick={() => setSelectedApp(null)}>
          <div style={{
            width: "700px", background: "rgba(0, 20, 40, 0.95)", border: "2px solid #00ffff",
            borderRadius: "30px", padding: "40px", display: "flex", gap: "30px",
            boxShadow: "0 0 100px rgba(0, 255, 255, 0.2)", position: "relative"
          }} onClick={e => e.stopPropagation()}>
            
            <div style={{ flex: 1 }}>
              <h2 style={{ color: "#00ffff", fontSize: "28px" }}>{selectedApp.name}</h2>
              <p style={{ marginTop: "20px", fontSize: "16px", lineHeight: "1.6", opacity: 0.8 }}>{selectedApp.description}</p>
              <div style={{ marginTop: "30px", color: "#00ffff", fontWeight: "bold" }}>
                Status: <span style={{ color: "#00ff00" }}>Optimized for NeuralLink & Android v40</span>
              </div>
            </div>

            <div style={{ width: "200px", textAlign: "center" }}>
              <div style={{ width: "180px", height: "180px", background: "#fff", padding: "10px", borderRadius: "10px", margin: "0 auto" }}>
                {/* Aquí iría un componente de QR real, por ahora un placeholder futurista */}
                <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${selectedApp.qr}`} alt="QR" style={{ width: "100%" }} />
              </div>
              <p style={{ fontSize: "12px", marginTop: "15px", color: "#00ffff" }}>ESCANEAR PARA INSTALACIÓN</p>
              <button style={{ 
                marginTop: "20px", width: "100%", background: "#00ffff", border: "none", 
                padding: "10px", fontWeight: "bold", borderRadius: "5px", cursor: "pointer" 
              }}>DESCARGAR BINARIO</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreFrancoLab;